<template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Tariff Benefits</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Tariff Benefits</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Tariff Benefits</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.tarf }}</v-subheader>
                <div class="queryValue" v-for="item in filterTarfList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.tarf"
                  :items="tarfList"
                  v-model="form.tarf"
                  item-text="value"
                  item-value="code"
                  data-vv-name="tarf"
                  :data-vv-as="labels.tarf"
                  :error-messages="errors.collect('tarf')"
                  v-validate="'required|max:1'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.busCls }}</v-subheader>
                <div class="queryValue" v-for="item in filterBusClsList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.busCls"
                  :items="busClsList"
                  v-model="form.busCls"
                  item-text="value"
                  item-value="code"
                  data-vv-name="busCls"
                  :data-vv-as="labels.busCls"
                  :error-messages="errors.collect('busCls')"
                  v-validate="'required|max:4'"
                ></v-autocomplete>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.benefit }}</v-subheader>
                <div class="queryValue" v-for="item in filterBenefitList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.benefit"
                  :items="benefitList"
                  v-model="form.benefit"
                  item-text="value"
                  item-value="code"
                  data-vv-name="benefit"
                  :data-vv-as="labels.benefit"
                  :error-messages="errors.collect('benefit')"
                  v-validate="'required|max:4'"
                ></v-autocomplete>
              </v-flex>
              <!-- SSY: New drop down list prtSchedDetSumm -->
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.prtSchedDetSumm }}</v-subheader>
                <div class="queryValue" v-for="item in filterPrtSchedDetSummList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.prtSchedDetSumm"
                  :items="prtSchedDetSummList"
                  v-model="form.prtSchedDetSumm"
                  item-text="value"
                  item-value="code"
                  data-vv-name="prtSchedDetSumm"
                  :data-vv-as="labels.prtSchedDetSumm"
                  :error-messages="errors.collect('prtSchedDetSumm')"
                  v-validate="'required|max:4'"
                ></v-autocomplete>
              </v-flex>
              <!-- SSY: New drop down list prtSchedDetSumm -->
              <!-- <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{labels.prtSchedDetSumm}}</v-subheader>
                <div class="queryValue" v-for="item in filterPrtSchedDetSummList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete :label="labels.prtSchedDetSumm" :items="prtSchedDetSummList" v-model="form.prtSchedDetSumm" item-text="value" item-value="code" data-vv-name="prtSchedDetSumm" :data-vv-as="labels.prtSchedDetSumm" :error-messages="errors.collect('prtSchedDetSumm')" v-validate="'required|max:4'"></v-autocomplete>
              </v-flex> -->
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.effDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(cloneQueryEffDate) }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <cal-picker
                  :label="labels.effDate"
                  v-model="form.effDate"
                  :error-messages="errors.collect('effDate')"
                  data-vv-name="effDate"
                  :data-vv-as="labels.effDate"
                  v-validate="effDateValidation"
                ></cal-picker>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.expDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(cloneQueryExpDate) }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <cal-picker
                  :label="labels.expDate"
                  v-model="form.expDate"
                  :error-messages="errors.collect('expDate')"
                  data-vv-name="expDate"
                  :data-vv-as="labels.expDate"
                  v-validate="expDateValidation"
                ></cal-picker>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.benType }}</v-subheader>
                <div class="queryValue" v-for="item in filterBenTypeList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.benType"
                  :items="benTypeList"
                  v-model="form.benType"
                  item-text="value"
                  item-value="code"
                  data-vv-name="benType"
                  :data-vv-as="labels.benType"
                  :error-messages="errors.collect('benType')"
                  v-validate="'required|max:1'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs3>
                <v-checkbox
                  :readonly="queryMode"
                  v-model="form.defBen"
                  :label="labels.defBen"
                  :error-messages="errors.collect('defBen')"
                  data-vv-name="defBen"
                  :data-vv-as="labels.defBen"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>

              <v-flex xs3>
                <v-checkbox
                  :readonly="queryMode"
                  v-model="form.addBen"
                  :label="labels.addBen"
                  :error-messages="errors.collect('addBen')"
                  data-vv-name="addBen"
                  :data-vv-as="labels.addBen"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.minSI }}</v-subheader>
                <div class="queryValue">{{ form.minSI }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.minSI"
                  :label="labels.minSI"
                  :error-messages="errors.collect('minSI')"
                  data-vv-name="minSI"
                  :data-vv-as="labels.minSI"
                  v-validate="'mask_decimal:2|mask_min_value:0.00'"
                ></v-text-field>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.maxSI }}</v-subheader>
                <div class="queryValue">{{ form.maxSI }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.maxSI"
                  :label="labels.maxSI"
                  :error-messages="errors.collect('maxSI')"
                  data-vv-name="maxSI"
                  :data-vv-as="labels.maxSI"
                  v-validate="'mask_decimal:2|mask_min_value:0.00'"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.basedUOM }}</v-subheader>
                <div class="queryValue">{{ form.basedUOM }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  v-model="form.basedUOM"
                  :label="labels.basedUOM"
                  :error-messages="errors.collect('basedUOM')"
                  data-vv-name="basedUOM"
                  :data-vv-as="labels.basedUOM"
                  v-validate="'mask_decimal:0'"
                ></v-text-field>
              </v-flex>

              <v-flex xs3>
                <v-checkbox
                  :readonly="queryMode"
                  v-model="form.protSI"
                  :label="labels.protSI"
                  :error-messages="errors.collect('protSI')"
                  data-vv-name="protSI"
                  :data-vv-as="labels.protSI"
                  v-validate="'required'"
                ></v-checkbox>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.gapCalcMethod }}</v-subheader>
                <div class="queryValue" v-for="item in filterGapCalcMethodList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.gapCalcMethod"
                  :items="gapCalcMethodList"
                  v-model="form.gapCalcMethod"
                  item-text="value"
                  item-value="code"
                  data-vv-name="gapCalcMethod"
                  :data-vv-as="labels.gapCalcMethod"
                  :error-messages="errors.collect('gapCalcMethod')"
                  v-validate="'required'"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.napSubLevel }}</v-subheader>
                <div class="queryValue" v-for="item in filterSubNapLevelList" :key="item.code">{{ item.value }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-autocomplete
                  :label="labels.napSubLevel"
                  :items="napList"
                  v-model="form.napSubLevel"
                  item-text="value"
                  item-value="code"
                  v-validate="'required'"
                  data-vv-name="napSubLevel"
                  :data-vv-as="labels.napSubLevel"
                  :error-messages="errors.collect('napSubLevel')"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
              <f-flex xs12>
                <v-spacer class="mt-2"></v-spacer>
                <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
                  <span>Cancel</span>
                  <v-icon right dark>mdi-cancel</v-icon>
                </v-btn>
                <v-btn :disabled="queryMode" color="primary" dark class="mr-2" @click="doSave" :loading="submitting">
                  Save
                  <v-icon right>mdi-content-save</v-icon>
                </v-btn>
              </f-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate, removeTime } from '@/utils/date'
import clone from 'clone'
export default {
  data() {
    return {
      labels: {
        tarf: 'Tariff',
        busCls: 'Business Class',
        benefit: 'Benefit',
        benType: 'Benefit Type',
        prtSchedDetSumm: 'Print Schedule',
        gapCalcMethod: 'GAP Calculation Method',
        tarfDesc: 'Tariff Description',
        benDesc: 'Benefit Description',
        busClsDesc: 'Business Class Description',
        effDate: 'Effective Date',
        expDate: 'Expiry Date',
        defBen: 'Default Benefit',
        addBen: 'Additional Benefit',
        protSI: 'Protect SI',
        napSubLevel: 'NAP Sub Level',
        basedUOM: 'Based UOM',
        minSI: 'Minimum SI',
        maxSI: 'Maximum SI',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        tarf: '',
        busCls: '',
        benefit: '',
        benType: 'P',
        prtSchedDetSumm: 'D',
        gapCalcMethod: 'S',
        tarfDesc: '',
        benDesc: '',
        busClsDesc: '',
        effDate: new Date(),
        expDate: new Date(),
        defBen: false,
        addBen: false,
        protSI: false,
        napSubLevel: 1,
        basedUOM: 1,
        minSI: 0,
        maxSI: 0
      },
      cloneQueryEffDate: '',
      cloneQueryExpDate: '',
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      busClsList: [],
      tarfList: [],
      benefitList: [],
      benTypeList: [
        { code: 'D', value: 'Discount' },
        { code: 'L', value: 'Loading' },
        { code: 'P', value: 'Premium' }
      ],
      prtSchedDetSummList: [
        { code: 'N', value: 'No' },
        { code: 'D', value: 'Detail' },
        { code: 'S', value: 'Summary' },
        { code: 'B', value: 'Basic' }
      ],
      gapCalcMethodList: [
        { code: 'A', value: 'A - Marine Cargo' },
        { code: 'E', value: 'E - Manually' },
        { code: 'I', value: 'I - Standard Individual (Insured)' },
        { code: 'L', value: 'L - NAP Subtotal Level' },
        { code: 'M', value: 'M - Motor Points (Multiplicative)' },
        { code: 'N', value: 'N - Motor NCD/NCB Rate' },
        // AR: Replaced to follow N2 4Nov2020 { code: 'P', value: 'Motor Points (Additive)' },
        { code: 'C', value: 'C - Motor Points (Additive)' },
        { code: 'S', value: 'S - Standard' }
      ],
      napList: [
        { code: 1, value: 1 },
        { code: 2, value: 2 },
        { code: 3, value: 3 },
        { code: 4, value: 4 },
        { code: 5, value: 5 },
        { code: 6, value: 6 },
        { code: 7, value: 7 },
        { code: 8, value: 8 },
        { code: 9, value: 9 }
      ]
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getTarfBen
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.tarf = data.tarfBenDto.tarf
            this.form.busCls = data.tarfBenDto.busCls
            this.form.benefit = data.tarfBenDto.benefit
            this.form.benType = data.tarfBenDto.benType
            this.form.gapCalcMethod = data.tarfBenDto.gapCalcMethod
            this.form.tarfDesc = data.tarfBenDto.tarfDesc
            this.form.benDesc = data.tarfBenDto.benDesc
            this.form.busClsDesc = data.tarfBenDto.busClsDesc
            this.form.effDate = data.tarfBenDto.effDate
            this.form.expDate = data.tarfBenDto.expDate
            this.form.defBen = data.tarfBenDto.defBen
            this.form.addBen = data.tarfBenDto.addBen
            this.form.protSI = data.tarfBenDto.protSI
            this.form.napSubLevel = data.tarfBenDto.napSubLevel
            this.form.basedUOM = data.tarfBenDto.basedUOM
            this.form.minSI = data.tarfBenDto.minSI
            this.form.maxSI = data.tarfBenDto.maxSI
            this.form.prtSchedDetSumm = data.tarfBenDto.prtSchedDetSumm
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
          this.cloneQueryEffDate = clone(this.form.effDate)
          this.cloneQueryExpDate = clone(this.form.expDate)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'tarfBenList' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
            // } else {
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createTarfBen
      if (apiURI) {
        this.submitting = true
        try {
          this.form.effDate = removeTime(this.form.effDate)
          this.form.expDate = removeTime(this.form.expDate)
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateTarfBen
      if (apiURI) {
        this.submitting = true
        try {
          this.form.effDate = removeTime(this.form.effDate)
          this.form.expDate = removeTime(this.form.expDate)
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doFetchBusClsList() {
      const apiURI = this.menu.getBusClsAndDesc
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.busClsList = []
            const { data } = result.data
            if (data) {
              data.map((dataMap) => {
                const convertList = {
                  code: dataMap.busCls,
                  value: dataMap.busCls + ' - ' + dataMap.busClsDesc,
                  desc: dataMap.busClsDesc
                }
                this.busClsList.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchTariffList() {
      const apiURI = this.menu.getTarfAndDesc
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.tarfList = []
            const { data } = result.data
            if (data) {
              data.map((dataMap) => {
                const convertList = {
                  code: dataMap.tarf,
                  value: dataMap.tarf + ' - ' + dataMap.tarfDesc,
                  desc: dataMap.tarfDesc
                }
                this.tarfList.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doFetchBenefitList() {
      const apiURI = this.menu.getBenefitAndDesc
      if (apiURI) {
        this.loading = true
        this.$http
          .get(apiURI)
          .then((result) => {
            this.benefitList = []
            const { data } = result.data
            if (data) {
              data.map((dataMap) => {
                const convertList = {
                  code: dataMap.benefit,
                  value: dataMap.benefit + ' - ' + dataMap.benDesc,
                  desc: dataMap.benDesc
                }
                this.benefitList.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.tariffBenefitsParam.menu
    },
    modeParam() {
      return this.$route.params.tarfBenMode
    },
    objParam() {
      return this.$route.params.tarfBenObjRes
    },
    filterBusClsList() {
      return this.busClsList.filter((list) => {
        return list.code === this.form.busCls
      })
    },
    filterBenefitList() {
      return this.benefitList.filter((list) => {
        return list.code === this.form.benefit
      })
    },
    filterPrtSchedDetSummList() {
      return this.prtSchedDetSummList.filter((list) => {
        return list.code === this.form.prtSchedDetSumm
      })
    },
    filterTarfList() {
      return this.tarfList.filter((list) => {
        return list.code === this.form.tarf
      })
    },
    filterBenTypeList() {
      return this.benTypeList.filter((list) => {
        return list.code === this.form.benType
      })
    },
    filterGapCalcMethodList() {
      return this.gapCalcMethodList.filter((list) => {
        return list.code === this.form.gapCalcMethod
      })
    },
    filterSubNapLevelList() {
      return this.napList.filter((list) => {
        return list.code === this.form.napSubLevel
      })
    },
    effDateValidation() {
      return 'required'
    },
    expDateValidation() {
      if (this.form.expDate !== undefined && this.form.expDate !== '') {
        return 'required|start_enddate:' + this.form.effDate
      } else {
        return 'required'
      }
    }
  },
  created() {
    this.doFetchBusClsList()
    this.doFetchTariffList()
    this.doFetchBenefitList()
    if (this.modeParam === 'create') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  mixins: [MessageMixin]
}
</script>
